<template>
  <div class='ou-tu-page'>
    <a-card :bordered='false' :bodyStyle="{paddingTop:'10px'}" :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <search-page-view
        ref='pageView'
        :query-params='listType!==2?queryProductParams:queryOrderParams'
        :columns='listType===2?getOrderColumns():getProColumns()'
        :col='3'
        :request-promise='geDataPromise'
        :itemNames="['s1']"
      >
        <a-form-item slot='s1' :label="listType!==2?'商品名称':'商户订单号'" v-bind='searchItemLayout'>
          <a-input v-if='listType!==2' v-model='queryProductParams.title' placeholder='请输入' allowClear></a-input>
          <a-input v-else v-model='queryOrderParams.orderNo' placeholder='请输入' allowClear></a-input>
        </a-form-item>
        <div slot='operation' style='margin-bottom: 20px;width: 100%'>
          <a-radio-group v-model='listType'>
            <a-radio-button :value='2'>订单直连</a-radio-button>
            <a-radio-button :value='1'>同步商品</a-radio-button>
            <a-radio-button :value='3'>黑名单商品</a-radio-button>
          </a-radio-group>
        </div>
        <template slot='customTitle' slot-scope='rowItem'>
          <span v-if='rowItem.record.productState===1' style='color: red'>{{ rowItem.text }}</span>
          <span v-else>{{ rowItem.text }}</span>
        </template>
        <template slot='action' slot-scope='rowItem'>
          <template v-if='listType!==2'>
            <template v-if='listType===1'>
              <a @click='onEditPriceEvent(rowItem.record)'>手动定价</a>
              <a-divider type='vertical'></a-divider>
            </template>
            <a
              @click='onBlackNameEvent(rowItem.record)'>{{
                queryProductParams.blackList === 0 ? '移入黑名单' : '移出黑名单'
              }}</a>
          </template>

        </template>
      </search-page-view>
      <a-modal
        v-if='showEditPriceDialog'
        title='手动定价'
        :visible='showEditPriceDialog'
        @cancel='showEditPriceDialog=false'
        :footer='null'
        width='600px'>
        <PriceEditorView
          :value='editPriceInfo'
          :submit-loading='submitLoading'
          @submit='updatePriceEvent'
        ></PriceEditorView>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'
import searchForm from '@/utils/mixins/searchFormMixins'
import PriceEditorView from '@/views/service/serviceProvider/oto/view/PriceEditorView'

export default {
  name: 'OuTuService',
  mixins: [ruleFormLayout, searchForm],
  components: { PriceEditorView },
  data() {
    return {
      listType: 1,//是商品 2是订单
      queryOrderParams: {
        orderType: 25,//固定类型
        orderNo: ''
      },
      queryProductParams: {
        title: '',
        platformId: '',
        merchantId: '',
        blackList: 0//是否黑名单 0不是 1是
      },
      submitLoading: false,
      showEditPriceDialog: false,
      editPriceInfo: {}
    }
  },
  watch: {
    'listType': function(newVal, oldVal) {
      if (newVal === 1) {
        this.queryProductParams.blackList = 0
      } else if (newVal === 3) {
        this.queryProductParams.blackList = 1
      }
      this.$nextTick(() => this.$refs.pageView.refresh(true))
    }
  },

  created() {
    let merchantId = this.$store.getters.userInfo.merchantId
    let platformId = this.getPlatformConfig().platformId
    this.queryProductParams.merchantId = merchantId
    this.queryProductParams.platformId = platformId
    this.queryAccountParams = { platformId, merchantId }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'OuTuService', title: '商品订单' },
      { name: 'LinkedAccountList', title: '关联账号' }
    ])
  },
  methods: {
    geDataPromise(parameter) {
      const path = this.listType !== 2 ? 'oto/product/queryOtoProductInfoList' : 'direct/getDirectOrderPage'
      const service = this.listType !== 2 ? this.getHttpServices().getServerApiService() : this.getHttpServices().getOrderService()
      return service.post(path, parameter)
    },
    getMemberListPromise(parameter) {
      return this.getHttpServices().getServerApiService().post('oto/product/queryOtoProductInfoList', parameter)
    },
    getProColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId'
        },
        {
          title: '供应商商品编号SKU',
          dataIndex: 'code'
        },
        {
          title: '商品标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'customTitle' }
        },
        {
          title: '类型',
          dataIndex: 'proType'
        },
        {
          title: '商品标题前缀',
          dataIndex: 'prefix'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getOrderColumns() {
      return [
        {
          title: '商户订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品标题',
          dataIndex: 'proName'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName'
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        }
      ]
    },
    onEditPriceEvent(record) {
      let { productId, advicePrice, peerPrice, commission, productStatus, marketPrice, purchasePrice } = record
      this.editPriceInfo = {
        productId,
        advicePrice,
        peerPrice,
        commission,
        marketPrice,
        purchasePrice,
        status: productStatus
      }
      this.showEditPriceDialog = true
    },
    onBlackNameEvent(record) {
      const { platformId, merchantId } = this.queryProductParams
      const params = {
        productId: record.productId,
        blackList: String(this.queryProductParams.blackList) === '1' ? 0 : 1,
        platformId,
        merchantId
      }
      this.getHttpServices().getServerApiService()
        .post('oto/product/modifyOtoProductInfoBlackList', params)
        .then(res => {
          this.$message.success('操作成功')
          this.$refs.pageView.refresh(true)
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
    },
    updatePriceEvent(params) {
      const { platformId, merchantId } = this.queryProductParams
      const updateParams = { ...params, platformId, merchantId }
      this.getHttpServices().getServerApiService()
        .post('oto/product/modifyOtoProductPrice', updateParams)
        .then(res => {
          this.showEditPriceDialog = false
          this.$refs.pageView.refresh(true)
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
    }

  }
}
</script>
<style scoped lang='less'>
.ou-tu-page {
  .filter-button {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
    background-color: transparent;
    color: transparent;
    z-index: 600;
  }
}

</style>